// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Labels = require("../../../reason/clients/components/Labels.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let AgentPropertyMlsStatus = require("../../common/Agent/AgentPropertyMlsStatus.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ForSalePropertyStatus_forSalePropertyV5_graphql = require("../../../__generated__/ForSalePropertyStatus_forSalePropertyV5_graphql.bs.js");

let convertFragment = ForSalePropertyStatus_forSalePropertyV5_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ForSalePropertyStatus_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ForSalePropertyStatus_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ForSalePropertyStatus_forSalePropertyV5_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ForSalePropertyStatus_forSalePropertyV5_graphql.node, convertFragment, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ForSaleProperty__Status$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(ForSalePropertyStatus_forSalePropertyV5_graphql.node, convertFragment, props.property);
  let match = property.status;
  let tmp;
  switch (match.__typename) {
    case "ExpiredProperty" :
      tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          JsxRuntime.jsx(Labels.ExpiredStatusLabel.make, {}),
          JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
            property: property.fragmentRefs,
            size: props.size
          })
        ]
      });
      break;
    case "SoldProperty" :
      tmp = JsxRuntime.jsx(Labels.SoldLabel.make, {});
      break;
    case "UnderContractProperty" :
      tmp = JsxRuntime.jsx(Labels.UnderContractLabel.make, {});
      break;
    case "WithdrawnProperty" :
      tmp = JsxRuntime.jsx(Labels.WithdrawnLabel.make, {});
      break;
    case "ActiveProperty" :
    case "__unselected" :
      tmp = JsxRuntime.jsx(AgentPropertyMlsStatus.make, {
        property: property.fragmentRefs
      });
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex gap-4"
  });
}

let WithoutErrorBoundary = {
  make: ForSaleProperty__Status$WithoutErrorBoundary
};

function ForSaleProperty__Status(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property status",
    children: JsxRuntime.jsx(ForSaleProperty__Status$WithoutErrorBoundary, {
      property: props.property,
      size: props.size
    })
  });
}

let make = ForSaleProperty__Status;

exports.PropertyFragment = PropertyFragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Labels Not a pure module */
